import { WarningDialog } from '@strata/react-dialog';
import { decode } from '@strata/react-question-tree';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

export const QuestionDeleteDialog = ({
    question = undefined,
    isOpen,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
}) => (
    <WarningDialog
        dialogTitle="Delete Question"
        isOpen={isOpen}
        primaryButtonLabel="Yes, Delete"
        onPrimaryButtonClick={onPrimaryButtonClick}
        secondaryButtonLabel="No, Cancel"
        onSecondaryButtonClick={onSecondaryButtonClick}
        dialogContent={
            <>
                <div className="padding__bottom--large">
                    Are you sure you want to delete this question?
                </div>
                <Formik initialValues={{}}>{(formik) => decode({ question, formik })}</Formik>
            </>
        }
    />
);

QuestionDeleteDialog.propTypes = {
    question: PropTypes.shape({}),
    isOpen: PropTypes.bool.isRequired,
    onPrimaryButtonClick: PropTypes.func.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
};
